<template>

    <div class="guia-orientacion row-start">

        <div class="imagen" v-if="!!data.urlFichero">
            <img :src="data.ulrImagen" :alt="data.titulo">
        </div>

        <div class="texto">
            <h2>{{data.titulo}}</h2>
            <p v-if="show" v-html="data.descripcion"></p>
            <a class="show-more" @click="show = !show">{{(show) ? $t('ver_menos') : $t('ver_mas') }}</a>
        </div>

        <a class="download-container" v-if="!!data.urlFichero" :href="data.urlFichero" target="_blank">
            <download></download>
        </a>




    </div>

</template>


<script>

    import download from '@/components/parts/icons/download'

    export default {
        name: 'guia-orientacion',
        props: ['data'],
        data() {
            return {
                show: false
            }
        },
        components: {
            'download': download,
        }
    }

</script>


<style lang="scss" scoped>
    .guia-orientacion {

        align-items: flex-start;
        position: relative;
        padding-bottom: 20px;
        margin-top: 20px;

        &:first-child {
            margin-top: 0;
        }

        &:last-child {
            border-bottom: none;
        }

        .imagen {
            width: 80px;
            height: auto;
            display: flex;
            justify-content: center;
            align-items: flex-start;

            img {
                max-width: 100%;
                max-height: 150px;
                display: inline-block;
            }
        }

        .texto {
            max-width: calc(100% - 80px);
            padding-left: 20px;
            width: 100%;
            padding-right: 60px;
            min-height: 60px;

            h2 {
                font-weight: bold;
                font-size: 16px;
                margin-bottom: 10px;
                width: 100%;
                text-align: left;
            }

            p {
                width: 100%;
                text-align: left;
                display: inline-block;
                white-space: pre-wrap;
                line-height: 1.1em;
                position: relative;
            }

            .show-more {
                text-decoration: underline;
                font-weight: bold;
                text-align: left;
                display: inline-block;
                width: 100%;
                color: inherit
            }
        }

        .download-container {
            position: absolute;
            right: 0;
            top: 0;

            svg {
                width: 30px;
                height: 30px;
            }
        }


    }

    @media screen and (max-width:560px) {
        .guia-orientacion .texto {
            max-width: 100%;
            padding-left: 0;
            margin-top: 20px;
        }
    }
</style>


// WEBPACK FOOTER //
// submodules/dotia-base-fp/src/components/parts/guia-orientacion.vue